import {
  FETCH_EXTERNAL_GROUP_RELATIONS,
  FETCH_EXTERNAL_GROUP_RELATIONS_SUCCESS,
  FETCH_EXTERNAL_GROUP_RELATIONS_FAILURE,
  DELETE_EXTERNAL_GROUP_RELATION_SUCCESS,
  DELETE_EXTERNAL_GROUP_RELATION_FAILURE,
  DELETE_EXTERNAL_GROUP_RELATION,
  UPDATE_EXTERNAL_GROUP_RELATION_SUCCESS,
  UPDATE_EXTERNAL_GROUP_RELATION_FAILURE,
  CREATE_EXTERNAL_GROUP_RELATION_SUCCESS,
  CREATE_EXTERNAL_GROUP_RELATION_FAILURE,
  CREATE_EXTERNAL_GROUP_RELATION,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAILURE,
  UPDATE_EXTERNAL_GROUP_RELATION,
  FETCH_GROUPS,
  IMPORT_EXTERNAL_GROUP_RELATION,
  IMPORT_EXTERNAL_GROUP_RELATION_SUCCESS,
  IMPORT_EXTERNAL_GROUP_RELATION_FAILURE
} from './actions';

import _ from 'lodash';
import { transformDatesToUI } from './utils/dateFieldUtils';
import { extractError } from './utils/egrSchema';

_.mixin({
  'mapKeysDeep': function (obj, fn) {
    const result = {};
    _.forOwn(obj, function(v, k) {
      if(_.isPlainObject(v)) {
        v = _.mapKeysDeep(v, fn);
      }
      result[fn(v, k)] = v;
    });
    return result;
  }
});

const DEFAULT_STATE = {
  externalGroupRelations: [],
  openedEditSections:     {},
  errors:                 [],
  notice:                 '',
  searchValue:            '',
  hasNextPage:            false,
  hasPrevPage:            false,
  startCursor:            null,
  endCursor:              null,
  isCreating:             false,
  isSearching:            false,
  isUpdating:             false,
  isImporting:            false
};

export const egrReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    // fetch
    case FETCH_EXTERNAL_GROUP_RELATIONS: {
      return {
        ...state,
        searchValue: action.payload.external_group_ids,
        legacyGroupIdsSearch: action.payload.legacy_group_ids,
        isSearching: true
      };
    }
    case FETCH_EXTERNAL_GROUP_RELATIONS_SUCCESS: {
      const errors = action.payload.data.externalGroupRelations && !_.isEmpty(action.payload.data.externalGroupRelations) ? [] : ['No match found'];
      return {
        ...state,
        externalGroupRelations: action.payload.data.externalGroupRelations.filter(egr => egr.node).map(egr => {
          egr.node.cursor = egr.cursor;
          egr.node = transformDatesToUI(egr.node);
          return egr.node;
        }),
        openedEditSections: {},
        errors,
        notice: '',
        startCursor: action.payload.data.pageInfo.startCursor,
        endCursor: action.payload.data.pageInfo.endCursor,
        hasPrevPage: action.payload.data.pageInfo.hasPreviousPage || false,
        hasNextPage: action.payload.data.pageInfo.hasNextPage || false,
        isSearching: false
      };
    }
    case FETCH_EXTERNAL_GROUP_RELATIONS_FAILURE: {
      return {
        ...state,
        errors: action.payload.map(e => extractError(e)),
        isSearching: false
      };
    }
    // delete
    case DELETE_EXTERNAL_GROUP_RELATION: {
      return {
        ...state
      }
    }
    case DELETE_EXTERNAL_GROUP_RELATION_SUCCESS: {
      const deletedEgr = action.payload.response.external_group_relation;
      return {
        ...state,
        notice: action.payload.response.notice,
        externalGroupRelations: state.externalGroupRelations.filter(egr => egr.externalGroupRelationId !== deletedEgr.external_group_relation_id)
      };
    }
    case DELETE_EXTERNAL_GROUP_RELATION_FAILURE: {
      return  {
        ...state,
        errors: action.payload.map(e => extractError(e))
      };
    }
    // update
    case UPDATE_EXTERNAL_GROUP_RELATION: {
      return {
        ...state,
        isUpdating: true
      };
    }
    case UPDATE_EXTERNAL_GROUP_RELATION_SUCCESS: {
      let egr = _.mapKeysDeep(action.payload.response.external_group_relation, (value, key) => _.camelCase(key));
      egr = transformDatesToUI(egr);
      const egrIndex = state.externalGroupRelations.findIndex(e => e.externalGroupRelationId === egr.externalGroupRelationId);
      const egrs = _.cloneDeep(state.externalGroupRelations);
      egrs[egrIndex] = egr;
      return {
        ...state,
        notice: action.payload.response.notice,
        openedEditSections: {
          ...state.openedEditSections,
          [egr.external_group_relation_id]: false
        },
        externalGroupRelations: egrs,
        errors: [],
        isUpdating: false
      };
    }
    case UPDATE_EXTERNAL_GROUP_RELATION_FAILURE: {
      return {
        ...state,
        errors: action.payload.map(e => extractError(e)),
        notice: '',
        isUpdating: false
      };
    }
    // create
    case CREATE_EXTERNAL_GROUP_RELATION: {
      return {
        ...state,
        isCreating: true
      };
    }
    case CREATE_EXTERNAL_GROUP_RELATION_SUCCESS: {
      let egr = _.mapKeysDeep(action.payload.response.external_group_relation, (value, key) => _.camelCase(key));
      egr = transformDatesToUI(egr);
      return {
        ...state,
        errors: [],
        notice: action.payload.response.notice,
        externalGroupRelations: [egr, ...state.externalGroupRelations],
        isCreating: false
      };
    }
    case CREATE_EXTERNAL_GROUP_RELATION_FAILURE: {
      return {
        ...state,
        errors: action.payload.map(e => extractError(e)),
        notice: '',
        isCreating: false
      };
    }
    default: {
      return state;
    }
  }
};

export const egrGroups = (state = { groups: [], errors: [], isSearching: false }, action) => {
  switch (action.type) {
    case FETCH_GROUPS: {
      return {
        ...state,
        isSearching: true
      };
    }
    case FETCH_GROUPS_SUCCESS: {
      const errors = _.isEmpty(action.payload.groups) ? ['No match found'] : [];
      return {
        ...state,
        groups: action.payload.groups,
        errors,
        isSearching: false
      };
    }
    case FETCH_GROUPS_FAILURE: {
      return {
        ...state,
        errors: action.payload.map(e => extractError(e)),
        isSearching: false
      };
    }
    default: {
      return state;
    }
  }
};

export const egrImport = (state = { isImporting: false, errors: [], notice: '' }, action) => {
  switch (action.type) {
    case IMPORT_EXTERNAL_GROUP_RELATION: {
      return {
        ...state,
        isImporting: true,
        notice:      ''
      };
    }
    case IMPORT_EXTERNAL_GROUP_RELATION_SUCCESS: {
      return {
        ...state,
        isImporting: false,
        errors:      [],
        notice:      action.payload.response.notice
      };
    }
    case IMPORT_EXTERNAL_GROUP_RELATION_FAILURE: {
      return {
        ...state,
        errors:      action.payload.map(e => extractError(e)),
        isImporting: false
      };
    }
    default: {
      return state;
    }
  }
};
